export default [
    { title: 'Caudal', id: 'item1', src: 'caudal.png', src_hover: 'caudal_h.png', route: '/HydrologicalInformationPdf'},
    { title: 'Nivel', id: 'item2', src: 'nivel.png', src_hover: 'nivel.png', route: '/HydrologicalInformationPdf'},
]